import React from "react";
import PropTypes from "prop-types";

import { PROFILE_MORE_LINK_COUNT_CLASSNAME } from "./constants";

export const ProfileMoreLinkLabel = ({ count }) => (
  <>
    More <span className={PROFILE_MORE_LINK_COUNT_CLASSNAME}>{count}</span>
  </>
);

ProfileMoreLinkLabel.propTypes = {
  count: PropTypes.number.isRequired,
};
